import { globalStore } from '../GlobalStore';
import { ChatMessageDTO, ChatRoomDTO, ChatUserBrief } from './MessageType';
import { getOtherUserId } from './MessageUtil';
import { MessageUserApi } from './MessageUserApi';

export const OFFICIAL_ACCOUNT_ID = 'Y001';

export function getSelfUserId(): string | undefined {
  return globalStore.currentBuyer?.buyerId;
}

export function getPeerUserId(
  room: ChatRoomDTO,
  messages?: ChatMessageDTO[],
): string | undefined {
  const fromMap = getOtherUserId(room, getSelfUserId() || '', 'buyer');
  if (fromMap) {
    return fromMap;
  }
  const selfId = getSelfUserId() || '';
  if (!messages?.length) {
    return undefined;
  }
  for (const msg of messages) {
    if (
      msg.fromUserId &&
      !msg.isSystem &&
      msg.fromUserId !== selfId
    ) {
      return msg.fromUserId;
    }
  }
  return undefined;
}

export function getMemberRole(
  room: ChatRoomDTO | undefined,
  userId: string,
): string | undefined {
  if (!room?.memberRoleMap) {
    return undefined;
  }
  return room.memberRoleMap[userId];
}

export function getSelfUserBrief(): ChatUserBrief {
  const buyer = globalStore.currentBuyer;
  if (!buyer) {
    return { name: '我', avatar: '' };
  }
  return {
    name: buyer.nickname || buyer.trueName || '我',
    avatar: buyer.avatarUrl || '',
  };
}

async function fetchSellerBrief(userId: string): Promise<ChatUserBrief | null> {
  console.info('[Message] getSellerOpenInfo', { userIds: [userId] });
  const list = await MessageUserApi.getSellerOpenInfo([userId]);
  const seller = list?.[0];
  if (!seller) {
    return null;
  }
  return {
    name: seller.nickname || userId,
    avatar: seller.avatarUrl || '',
  };
}

async function fetchBuyerBrief(userId: string): Promise<ChatUserBrief | null> {
  console.info('[Message] getBuyerInfo', { buyerIds: [userId] });
  const list = await MessageUserApi.getBuyerPublicInfo([userId]);
  const buyer = list?.[0];
  if (!buyer) {
    return null;
  }
  return {
    name: buyer.nickname || buyer.trueName || userId,
    avatar: buyer.avatarUrl || '',
  };
}

/** memberRole 来自 memberRoleMap，不对 userId 做任何裁剪或前缀判断 */
export async function fetchChatUserInfo(
  userId: string,
  memberRole?: string,
): Promise<ChatUserBrief> {
  console.info('[Message] fetchChatUserInfo', {
    userId,
    memberRole,
    selfUserId: getSelfUserId(),
  });

  if (userId === OFFICIAL_ACCOUNT_ID) {
    return { name: '圆领平台官方', avatar: '/logo.svg' };
  }

  const selfId = getSelfUserId();
  if (selfId && userId === selfId) {
    return getSelfUserBrief();
  }

  if (memberRole === 'seller') {
    return (await fetchSellerBrief(userId)) || { name: userId, avatar: '' };
  }
  if (memberRole === 'buyer') {
    return (await fetchBuyerBrief(userId)) || { name: userId, avatar: '' };
  }

  // 买家 Web 单聊默认对方为卖家
  return (await fetchSellerBrief(userId)) || { name: userId, avatar: '' };
}
